export default {
  // 中介销售模块
  'menu.sales-agent': '中介销售',
  'menu.sales-agent.sales-overview': '销售总览',

  // 销售总览页面
  'pages.salesAgent.salesOverview.title': '销售总览',
  
  // 统计卡片
  'pages.salesAgent.salesOverview.totalSales': '总销售金额',
  'pages.salesAgent.salesOverview.totalUnits': '总销售套数',
  'pages.salesAgent.salesOverview.userRevenue': '用户回款总额',
  'pages.salesAgent.salesOverview.profitMargin': '利润库存 (车位/房)',
  
  // 趋势指标
  'pages.salesAgent.salesOverview.vsLastMonth': '较上月',
  'pages.salesAgent.salesOverview.forecast': '预测',
  'pages.salesAgent.salesOverview.returnRate': '回款率',
  'pages.salesAgent.salesOverview.vsLastYear': '去化周期',
  
  // 销售分析
  'pages.salesAgent.salesOverview.salesAnalysis': '销售分析',
  'pages.salesAgent.salesOverview.monthlyTrend': '月度业绩走势',
  'pages.salesAgent.salesOverview.salesAmount': '金额(万)',
  'pages.salesAgent.salesOverview.salesCount': '套数',
  'pages.salesAgent.salesOverview.businessStructure': '业态构成',
  
  // 业态类型
  'pages.salesAgent.salesOverview.residential': '普通住宅',
  'pages.salesAgent.salesOverview.commercial': '商业商铺',
  'pages.salesAgent.salesOverview.parking': '地下车位',
  
  // 楼盘销售与库存监控
  'pages.salesAgent.salesOverview.projectMonitoring': '楼盘销售与库存监控',
  'pages.salesAgent.salesOverview.projectName': '楼盘名称',
  'pages.salesAgent.salesOverview.type': '类型',
  'pages.salesAgent.salesOverview.totalAmount': '销售金额(万)',
  'pages.salesAgent.salesOverview.totalCount': '总套数',
  'pages.salesAgent.salesOverview.soldReserved': '已售/预订',
  'pages.salesAgent.salesOverview.inventory': '剩余库存',
  'pages.salesAgent.salesOverview.depletion': '去化进度',
  
  // 类型标签
  'pages.salesAgent.salesOverview.type.residential': '住宅',
  'pages.salesAgent.salesOverview.type.commercial': '商铺',
  'pages.salesAgent.salesOverview.type.parking': '车位',
  
  // 月份
  'pages.salesAgent.salesOverview.month.4': '4月',
  'pages.salesAgent.salesOverview.month.5': '5月',
  'pages.salesAgent.salesOverview.month.6': '6月',
  'pages.salesAgent.salesOverview.month.7': '7月',
  'pages.salesAgent.salesOverview.month.8': '8月',
  'pages.salesAgent.salesOverview.month.9': '9月',
};
